import { GridToolbarContainer, GridToolbarExport, NoRowsOverlayPropsOverrides } from "@mui/x-data-grid";
import { ReportLoadingType } from "../ReportPageModels";

export interface PaginationModel {
    pageSize: number;
    page: number;
}

export function ExportToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarExport />
        </GridToolbarContainer>
    );
}

declare module '@mui/x-data-grid' {
    interface NoRowsOverlayPropsOverrides {
        reportLoadingType: ReportLoadingType;
    }
}
export function CustomNoRowsOverlay(props: NoRowsOverlayPropsOverrides) {
    //https://acegif.com/wp-content/gif/hamster-wheel-46.gif hamster loading
    //https://gowhsehub.io/wp-content/uploads/2021/06/truck-loading-animation.gif van loading
    //https://media.giphy.com/media/axvPzNxtf9LTG/giphy.gif dog loading
    //https://media.giphy.com/media/hDI4sYoJ6hdjp2DmX5/giphy.gif Ray's loader

    //https://cdn.dribbble.com/users/176572/screenshots/1261789/dribbble_14.gif carcarsh error

    //https://thumbs.gfycat.com/CaringLightheartedCatfish-size_restricted.gif perekatipole norecords

    // https://ios-icc-components.s3.eu-west-1.amazonaws.com/report-app-components/loaders/car-loader.gif Ray's great loading 
    return (
        <>
            {props.reportLoadingType === ReportLoadingType.Loading ?
                <div>
                    <img
                        src="https://ios-icc-components.s3.eu-west-1.amazonaws.com/report-app-components/loaders/reportLoading.gif"
                        alt="loading"
                        width="400px"
                        style={{ marginLeft: "600px", marginTop: "30px" }} />

                    <h1 style={{ textAlign: 'center' }}>Loading...</h1>
                </div> : null}
            {props.reportLoadingType === ReportLoadingType.Error ?
                <>
                    <img
                        src="https://ios-icc-components.s3.eu-west-1.amazonaws.com/report-app-components/loaders/reportError.gif"
                        alt="error images"
                        width="400px"
                        style={{ marginLeft: "600px", marginTop: "30px" }} />

                    <h1 style={{ textAlign: 'center' }}>Loading error. Contact developers</h1>
                </> : null}
            {props.reportLoadingType === ReportLoadingType.Noreports ?
                <>
                    <img
                        src="https://ios-icc-components.s3.eu-west-1.amazonaws.com/report-app-components/loaders/reportNoRecords.gif"
                        alt="no reports"
                        width="400px"
                        style={{ marginLeft: "600px", marginTop: "30px" }} />

                    <h1 style={{ textAlign: 'center' }}>No records</h1>
                </> : null}
            {props.reportLoadingType == ReportLoadingType.SelectClient ?
                <div style={{ marginLeft: "730px", marginTop: "340px" }}>
                    <h2>Please select client</h2>
                </div>
                : null}

            {props.reportLoadingType == ReportLoadingType.SelectSalesman ?
                <div style={{ marginLeft: "730px", marginTop: "340px" }}>
                    <h2>Please select salesman</h2>
                </div>
                : null}

        </>
    );
}
